"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
var React = __importStar(require("react"));
var ProgressBar_scss_1 = __importDefault(require("./ProgressBar.scss"));
var ProgressBar = function (_a) {
    var props = __rest(_a, []);
    var itemWidth = 100 / props.total;
    var progressWidth = (props.current / props.total) * 100 - itemWidth / 2;
    var listItems = [];
    for (var i = 1; i <= props.total; i++) {
        listItems.push(React.createElement("li", { key: i, id: i.toString(), className: props.current == i ? ProgressBar_scss_1.default['current'] : props.current > i ? ProgressBar_scss_1.default['active'] : '', style: { width: itemWidth + '%' } },
            React.createElement("span", { className: ProgressBar_scss_1.default['dot'] },
                React.createElement("span", { "aria-describedby": 'step' + i + 'srdiv' }, i))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "content-progressbar" },
            React.createElement("nav", { className: ProgressBar_scss_1.default['progress-container'], role: "navigation" },
                React.createElement("div", { className: props.current == props.total ? ['progress-steps', 'progress-steps-complete'].map(function (r) { return ProgressBar_scss_1.default[r]; }).join(' ') : ProgressBar_scss_1.default['progress-steps'] },
                    React.createElement("span", { id: "progress-percent", style: { width: progressWidth + '%' } })),
                React.createElement("ul", { className: ProgressBar_scss_1.default['section-nav'] }, listItems)))));
};
exports.ProgressBar = ProgressBar;
//# sourceMappingURL=ProgressBar.js.map